import BaseResourceService from "./BaseResourceService";

export default class DocumentsService extends BaseResourceService {
  static get baseURL() {
    return this.apiUrl + "documents";
  }

  static getDocumentPreviewUrl(uuid) {
    return this.baseURL + "/" + uuid + "/preview";
  }
}
